import { Select } from '../../../components/select/select';
import { useSelector } from 'react-redux';
import { APP_STATE } from '../../../store/reducers';
import './userCountryLangCell.scss';
import { INewUpdatedUser } from '../manageUsersModel';
import { setCountryLanguage } from '../../../utils/manageUserHelpers';

interface NewUserTextCellRendererProps {
  colDef?: any;
  data?: any;
  onDomainRowChange: (
    name: string,
    value: { label: string; value: string },
    rowData: any
  ) => void;
  domainUsers: INewUpdatedUser[];
}

const defaultLang = {
  value: 'en',
  label: 'English',
};

export const UserCountryLangCellRenderer = (
  props: NewUserTextCellRendererProps
) => {
  const columnDef = props?.colDef;
  const user = props?.data?.userDetails;
  const domainList = props.domainUsers;
  const { projectCountries } = useSelector(
    (state: APP_STATE) => state.dataLocationsReducer
  );
  const manageUserData = useSelector(
    (state: APP_STATE) => state.manageUserReducer
  );

  const getSelectOptions = () => {
    if (columnDef?.field === 'userCountry') {
      return projectCountries.map((country) => ({
        value: country.key,
        label: country.name,
      }));
    }
    return manageUserData.userLanguage.map((v) => ({
      value: v.key,
      label: v.name,
    }));
  };

  const getDefaultValue = () => {
    if (domainList?.length && user?.isAllowedDomain) {
      const currentUser = domainList.find((v) => v.mail === user?.mail);
      if (currentUser) {
        const updatedData = setCountryLanguage(
          currentUser,
          columnDef?.field,
          projectCountries,
          manageUserData.userLanguage
        );
        return updatedData;
      } else {
        if (columnDef?.field === 'userLanguage') {
          return defaultLang;
        }
      }
    } else {
      if (columnDef?.field === 'userLanguage') {
        return defaultLang;
      }
      return {
        value: '',
        label: '',
      };
    }
  };
  return (
    (user && (
      <div
        className={`new-user-dropdown ${
          user?.isAllowedDomain && !getDefaultValue()?.value?.length
            ? 'empty'
            : ''
        }`}
      >
        {user?.isNewAddedRow && user?.isAllowedDomain ? (
          <Select
            options={getSelectOptions()}
            defaultValue={getDefaultValue()}
            closeMenuOnSelect
            width={300}
            placeholder="None"
            onValueChange={(value) => {
              props.onDomainRowChange(columnDef?.field, value, user);
            }}
          />
        ) : (
          <div className="user-details">
            {columnDef?.field === 'userCountry'
              ? user?.country
              : user?.language}
          </div>
        )}
      </div>
    )) ||
    null
  );
};
